// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__BaQ_P","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2zq2q","obliqueLine":"membershipbadge_obliqueLine__1YsWz"};